import { Sidebar as AppSidebar } from '../../components'
import { useLayoutContext } from '../layout.context'

export const Sidebar = () => {
  const { setShowSidebar, showSidebar } = useLayoutContext()

  return <AppSidebar show={showSidebar} onClose={() => setShowSidebar(false)} />
}
